import { defineComponent, useCssVars, computed, createElementBlock, openBlock, normalizeClass, renderSlot } from "vue";
import { _export_sfc } from "../WAccordion/index.js";
import './index.css';const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WCell",
  props: {
    size: {},
    spacing: {},
    level: { default: 0 }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "54224e36": props.level
    }));
    const props = __props;
    const classes = computed(() => [
      `--size-${props.size}`,
      `--spacing-${props.spacing}`
    ]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["w-cell", classes.value])
      }, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 2);
    };
  }
});
const WCell = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-39e9e41b"]]);
export {
  WCell
};
